import { render, staticRenderFns } from "./SwitchProgramInfoModal.vue?vue&type=template&id=67be2228&scoped=true&"
import script from "./SwitchProgramInfoModal.vue?vue&type=script&lang=js&"
export * from "./SwitchProgramInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be2228",
  null
  
)

export default component.exports